import React, { useCallback, useEffect, useState } from 'react';

/**
 * Prompt after a new service worker installs (skipWaiting). Reload applies the update.
 */
function UpdateAvailablePrompt() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const show = () => setVisible(true);
    window.addEventListener('quran-sw-update', show);
    return () => window.removeEventListener('quran-sw-update', show);
  }, []);

  const onReload = useCallback(() => {
    window.location.reload();
  }, []);

  const onLater = useCallback(() => {
    setVisible(false);
  }, []);

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-20 left-3 right-3 z-[65] flex items-center justify-between gap-3 rounded-2xl border border-teal-200 bg-white p-3 shadow-lg dark:border-teal-800 dark:bg-gray-900 sm:left-auto sm:right-4 sm:max-w-md"
      role="status"
    >
      <p className="text-sm text-gray-800 dark:text-gray-100">
        Update available. Reload to get the latest version.
      </p>
      <div className="flex shrink-0 gap-2">
        <button
          type="button"
          onClick={onLater}
          className="rounded-full px-3 py-1.5 text-sm text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800"
        >
          Later
        </button>
        <button
          type="button"
          onClick={onReload}
          className="rounded-full bg-teal-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-teal-700"
        >
          Reload
        </button>
      </div>
    </div>
  );
}

export default UpdateAvailablePrompt;
